<!-- History Drawer Component -->
<div class="history-drawer-container" [class.drawer-open]="isHistoryDrawerOpen">
  <div class="history-drawer">
    <div class="history-drawer-header">
      <h2>{{ historyTitle }}</h2>
      <button class="close-btn" (click)="closeHistoryDrawer()">
        <span class="close-icon">×</span>
      </button>
    </div>
    <div class="history-drawer-content">
      <!-- History timeline -->
      <div class="history-timeline">
        <div class="history-item" *ngFor="let item of historyData">
          <div class="time-column">{{ item?.TIS ?? 'NA' }}</div>
          <div class="status-dot">
            <div class="dot"></div>
          </div>
          <div class="status-column">
            <div class="status-label" [ngStyle]="{
              'background-color': historyBackgroundColorMapping[item?.trackedState] ?? 'rgba(139, 139, 139, 1)',
              'color': summaryColorMapping[item.trackedState] || 'rgba(139, 139, 139, 1)'
            }">
              {{ getStatusName(item?.trackedState) ?? 'NA' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- tile -->
<section
  class="zone-planogram-body"
  *ngIf="planogramEntityList?.length; else noDataTemplate"
>
  <div class="tile-container" *ngFor="let entity of planogramEntityList; trackBy: trackByEntityId">
    <!-- Tag positioned outside the tile but inside the container -->
    <div class="left-decoration-item" [matTooltip]="entity?.workTableZone?.length?entity?.workTableZone?.[0]?.name:'NA'">
      {{ (entity?.workTableZone?.[0]?.name || 'NA') | truncate:12:'..' }}
    </div>
    
    <div
      class="z-p-tile"
      [ngClass]="'tracked-state-' + (entity?.trackedState ?? 'null')"
      [ngStyle]="{
        'background-color': backgroundColorMapping[entity?.trackedState ?? 'null']
      }"
    >
      <div class="z-p-top-content">
        <h4 class="z-p-header">
          <span class="info-icon" (click)="openHistoryDrawer(entity)" [matTooltip]="entity?.uniqueId">
            {{ entity?.uniqueId || 'NA' | truncate:13:'..' }}
          </span>
        </h4>
        <ul class="z-p-timer">
          <li>Last updated:</li>
          &nbsp;
          <li>
            {{
              entity?.sourceTimestamp
                ? entity.sourceTimeDisplayValue + " ago"
                : "NA"
            }}
          </li>
        </ul>
      </div>
      <div class="z-p-tile-row3">
        <div class="z-p-tile-row3-btn-tile"  [ngStyle]="{
          'color': summaryColorMapping[entity.trackedState] || 'rgba(139, 139, 139, 1)'
        }">{{ getStatusName(entity?.trackedState) }}</div>
        <div class="z-p-divider"></div>
        <div class="z-p-tile-time-details">
          {{ entity?.tisDisplayValue ?? "NA" }}
        </div>
      </div>
      <!-- <div class="z-p-time-range">
        <ng-container *ngIf="selectedDateRange?.label !== 'Custom'; else customDateRange">
          <span>{{ selectedDateRange?.label ?? 'NA' }}</span>
        </ng-container>
        <ng-template #customDateRange>
          <span class="z-p-custom-date">
            <span>{{ selectedDateRange?.startDate | date:'short' }}</span>&nbsp;-&nbsp;<span>{{ selectedDateRange?.endDate | date:'short' }}</span>
          </span>
        </ng-template>
      </div> -->
      <!-- Heat map with timelapse data -->
      <div class="z-p-heat-map">
        <div class="z-p-heat-map-bar" *ngIf="entity?.timelapse?.length; else defaultHeatMap">
          <div 
            *ngFor="let segment of entity.timelapse; trackBy: trackBySegmentIndex"
            class="z-p-heat-segment" 
            [ngStyle]="{
              'background-color': summaryColorMapping[segment.trackedState] || 'rgba(139, 139, 139, 1)',
              'width': calculateSegmentWidth(segment.value, entity.timelapseTotal)
            }"
            [matTooltip]="getStatusName(segment.trackedState) + ': ' + (segment.value | timeConversion) + ' (' + calculateSegmentWidth(segment.value, entity.timelapseTotal) + ')'">
          </div>
        </div>
        <!-- Default heat map if no timelapse data -->
        <ng-template #defaultHeatMap>
          <div class="z-p-heat-map-bar">
            <div
              class="z-p-heat-segment" 
              [ngStyle]="{
                'background-color': 'rgba(139, 139, 139, 1)',
                'flex-grow': 1,
                'width': '100%'
              }"
              [matTooltip]="entity?.uniqueId + ': No timelapse data available'">
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</section>
<!-- no data -->
<ng-template #noDataTemplate>
  <p class="p-no-data">No Data</p>
</ng-template>